module.exports = __webpack_public_path__ + "img/02n.f87cfdb2.png";